import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { PatternFormat } from 'react-number-format';
import { getTranslate } from '../../../utils/getTranslate/getTranslate';
import styles from '../FormPost.module.scss';

export const Content = ({ upApplication }) => {
  const t = getTranslate;
  const params = useParams();
  const { lang } = useParams();
  const { info, form } = !!upApplication ? upApplication.acf : {};
  const { title, text } = info;

  const renderField = (field_id, field_type, field_label) => {
    if (field_type === 'text') {
      return <input name={field_id} type="text" placeholder={field_label[lang]} required />;
    }
    if (field_type === 'email') {
      return <input name={field_id} type="email" placeholder={field_label[lang]} required />;
    }
    if (field_type === 'tel') {
      return (
        <PatternFormat
          format="+7 (###) ###-##-##"
          allowEmptyFormatting
          mask="_"
          name={field_id}
          className={styles.input}
          placeholder={field_label[lang]}
          required
        />
      );
    }
    if (field_type === 'date') {
      return <input key={field_id} name={field_id} type="date" required />;
    }
    if (field_type === 'textarea') {
      return <textarea key={field_id} name={field_id} placeholder={field_label[lang]} required></textarea>;
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formElement = e.target;

    const formData = new FormData(formElement);
    formData.append('action', 'save_application');
    formData.append('form_slug', title.ru || 'unknown');

    try {
      const response = await fetch('https://wp.bala.bokeylibrary.kz/wp-content/themes/main/form/query.php', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(lang === 'ru' ? 'Ошибка сервера. Попробуйте позже.' : 'Сервер қатесі. Кейінірек қайталаңыз.');
      }

      const result = await response.json();

      if (result.success) {
        alert(lang === 'ru' ? 'Заявка отправлена!' : 'Өтінім жіберілді!');
        formElement.reset();
      } else {
        alert(result.message || (lang === 'ru' ? 'Ошибка при отправке' : 'Жіберу қатесі'));
      }
    } catch (error) {
      console.error('Ошибка:', error);
      alert(
        lang === 'ru'
          ? 'Не удалось отправить форму. Проверьте интернет или попробуйте позже.'
          : 'Форманы жіберу мүмкін болмады. Интернетті тексеріңіз немесе кейінірек қайталаңыз.',
      );
    }
  };

  return (
    <section className={styles.content}>
      <div className="container">
        <div className={styles.content_body}>
          <div className={styles.content_form}>
            <form onSubmit={handleSubmit} className={styles.content_form_body}>
              <label className={styles.content_form_title}>{t('Форманы толтырыңыз', 'Заполните форму', lang)}</label>
              <div className={styles.content_form_row}>
                {!!form &&
                  form.map((el, idx) => {
                    const { info, field_label } = el;
                    const { field_id, field_type } = info;
                    return (
                      <div key={idx} className={styles.content_form_column}>
                        {renderField(field_id, field_type, field_label)}
                      </div>
                    );
                  })}
              </div>
              <button type="submit" className={styles.content_form_btn}>
                {t('Жіберу', 'Отправить', lang)}
              </button>
            </form>
          </div>
          <div className={styles.content_info}>
            <h2 className={`${styles.content_info_toptitle} global-subtitle`}>{t('Қолданбалар', 'Заявки', lang)}</h2>
            <h1 className={`${styles.content_info_title} global-title`}>{title[lang]}</h1>
            <div className={`${styles.content_info_text} global-text`} dangerouslySetInnerHTML={{ __html: text[lang] }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};
